import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import {uuid} from 'vue-uuid';
import cloneDeep from "lodash/cloneDeep";
import helperService from "@/core/services/helper.service";

export default class CommissionForm extends BaseModel {
  uuid = uuid.v4();
  minimum_commission = null;
  insurance_rate = null;
  lot_handling_charge = null;
  rebate_rate = null;
  commissions = [];

  constructor(data = {}, tax_rate = null) {
    super();
    data = helperService.reverseCalculateTiers(data, tax_rate)
    Object.assign(this, {...data});
  }

  getData() {
    return {
      minimum_commission: parseFloat(this.minimum_commission),
      insurance_rate: parseFloat(this.insurance_rate),
      lot_handling_charges: parseFloat(this.lot_handling_charge),
      rebate_rate: parseFloat(this.rebate_rate)
    };
  }

  rules = {
    minimum_commission: 'required',
    insurance_rate: 'required|max_value:100|min_value:0',
    lot_handling_charge: 'numeric|required|max:10',
    rebate_rate: 'required|max_value:100|min_value:0',
  };

  attributeLabels = {
    minimum_commission: i18n.t('Minimum Commission'),
    insurance_rate: i18n.t('L/D Warranty'),
    lot_handling_charge: i18n.t('Entry Fee'),
    rebate_rate: i18n.t('Rebate'),
    tax_status: i18n.t('Tax Status'),
    unsold_fee: i18n.t('Unsold Fee'),
    commissions: i18n.t('Commissions'),
    Over: i18n.t('Over'),
    payment_terms: i18n.t('Payment Terms'),
    withdrawal_fee: i18n.t('Withdrawal Fee'),
    settlement_days: i18n.t('Settlement Days'),
    credit_limit: i18n.t('Bidding Limit'),
    identity_verification: i18n.t('Identity Verification'),
  };

  toJSON(financialItem) {
    let data = cloneDeep(super.toJSON());
    data = helperService.calculateTiers(data, financialItem ? financialItem.tax_rate : null)
    return data
  }
}
